import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

import { roleEndpoints } from './role.constants'
import type {
  TCreateRoleRequest,
  TPermission,
  TRole,
  TUpdateRoleRequest,
} from './role.types'

export async function getRoleList(): Promise<TRole[]> {
  const res = await api.get<TResponse<TRole[]>>(roleEndpoints.list)
  return res.data.data
}

export async function getPermissionList(): Promise<TPermission[]> {
  const res = await api.get<TResponse<TPermission[]>>(roleEndpoints.permissions)
  return res.data.data
}

export async function createRole(body: TCreateRoleRequest): Promise<TRole> {
  const res = await api.post<TResponse<TRole>>(roleEndpoints.create, body)
  return res.data.data
}

export async function updateRole(
  id: string,
  body: TUpdateRoleRequest
): Promise<TRole> {
  const res = await api.patch<TResponse<TRole>>(roleEndpoints.update(id), body)
  return res.data.data
}
